module.exports = __webpack_public_path__ + "static/media/intergenerational_engagement.766f1dd4.png";